import IconChevron from '../icons/chevron_down.svg?component';

export const AdhocProps = {
    components: {
        IconChevron,
    },
    props: {
        /**
         * Показывать строку поиска или нет
         */
        showSearch: {
            type: Boolean,
            default: true,
        },
        /**
         * Заголовок поля
         */
        label: {
            type: String,
            required: true,
        },
        /**
         * Запись, когда ничего не выбрано
         */
        emptyValue: {
            type: String,
            default: 'Не выбрано',
        },
    },
};
